import { render, staticRenderFns } from "./UploadDataDialog.vue?vue&type=template&id=0c4cd7d6&scoped=true"
import script from "./UploadDataDialog.vue?vue&type=script&lang=js"
export * from "./UploadDataDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDataDialog.vue?vue&type=style&index=0&id=0c4cd7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4cd7d6",
  null
  
)

export default component.exports